const changeLocaleByPath = (pathname) => {
  if (pathname.includes('/en/')) {
    localStorage.setItem(
      'lang',
      JSON.stringify({
        country: 'Ukraine',
        lang: 'English',
      }),
    )
  } else if (pathname.includes('/ru/')) {
    localStorage.setItem(
      'lang',
      JSON.stringify({
        country: 'Ukraine',
        lang: 'русский',
      }),
    )
  } else {
    localStorage.setItem(
      'lang',
      JSON.stringify({
        country: 'Ukraine',
        lang: 'Українська',
      }),
    )
  }
}

export default changeLocaleByPath
